import axiosInstance from "@/composables/axios-instance";
import { toast } from "vue3-toastify";

const state = {
  defectiveReport: {
    results: [],
    total_defective_items_count: 0,
    total_defective_financial_value: 0
  }
};

const getters = {
  getDefectiveReport(state) {
    return state.defectiveReport;
  }
};

const mutations = {
  setDefectiveReport(state, data) {
    state.defectiveReport = data;
  }
};

const actions = {
  getDefectiveReportFromApi({ commit }, filter) {
    let params = {
      page: filter.page || 1,
      inventory: filter.inventory
    };
    if (filter.date_range) {
      params.date_range = filter.date_range;
    }
    if (filter.product) {
      params.product = filter.product;
    }
    if (filter.user) {
      params.user = filter.user;
    }

    return axiosInstance
      .get("/products/defective-report/", { params })
      .then((response) => {
        commit("setDefectiveReport", response.data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("خطا در دریافت گزارش کالاهای ضایعاتی");
      });
  },

  getDefectiveExcel(_, filter) {
    let params = {
      inventory: filter.inventory
    };
    if (filter && filter.date_range) {
      params.date_range = filter.date_range;
    }

    return axiosInstance
      .get("/products/defective-report/excel/", {
        params,
        responseType: "blob"
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const filename = "Defective_Items_Report.xlsx";
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        toast.success("فایل اکسل ضایعات با موفقیت دانلود شد");
      })
      .catch((error) => {
        console.error(error);
        toast.error("خطا در دانلود فایل اکسل ضایعات");
      });
  },
  
  fetchProductPriceTiers(_, { productId, inventoryId }) {
    return axiosInstance
      .get("/products/price-tiers/", {
        params: { product_id: productId, inventory: inventoryId }
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        toast.error("خطا در دریافت قیمت‌های موجود برای این کالا");
        return [];
      });
  },

  registerDefectiveItemAction(_, { payload, inventoryId }) {
    return axiosInstance
      .post("/products/register-defective/", payload, {
        params: { inventory: inventoryId }
      })
      .then(() => {
        toast.success("کالای ضایعاتی با موفقیت ثبت شد");
        return true;
      })
      .catch((error) => {
        console.error(error);
        const serverMessage = error.response?.data?.error;
        toast.error(serverMessage || "خطا در ثبت کالای ضایعاتی");
        return false;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};